import * as types from "./actionsTypes";
import { agent } from "../utils/agent";
import toggleNetworkRequestStatus from "./toggleNetworkRequestStatus";
import * as API from "../utils/apiPath";

export function loadEventDataSuccess(eventsData) {
	return { type: types.LOAD_EVENTS_DATA_SUCCESS, eventsData };
  }

export function loadEventData(type) {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));
    await agent
      .get(API.LOAD_EVENT + "/" + type)
      .then((response) => {
        dispatch(toggleNetworkRequestStatus(false));
        if (response.status === 200 || response.status === 201) {
          if (response.data.status === 200) {
            dispatch(loadEventDataSuccess(response.data.data));
          }
        }
      })
      .catch((error) => {
        dispatch(toggleNetworkRequestStatus(false));
        throw error;
      });
  };
}


export function handleSubmitRSVP(params, setShow, setLoader) {
  return async function (dispatch) {
    dispatch(toggleNetworkRequestStatus(true));

    try {
      const response = await agent.post(API.SUBMIT_RSVP, params);
      setLoader(false);
      dispatch(toggleNetworkRequestStatus(false));

      // ✅ Return response so component handles popup
      return response.data;

    } catch (error) {
      setLoader(false);
      dispatch(toggleNetworkRequestStatus(false));

      // ✅ Return error object to component
      return {
        status: error?.response?.status || 500,
        message: error?.response?.data?.message || "An unexpected error occurred.",
      };
    }
  };
}